"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2861],{

/***/ 28149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ PriceFilter; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81837);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21483);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88123);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36344);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4680);
/* harmony import */ var _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85212);
/* harmony import */ var _contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69168);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const PriceFilter = (_a) => {
  var _b = _a, {
    value,
    step = 1,
    onFilter,
    max,
    min
  } = _b, props = __objRest(_b, [
    "value",
    "step",
    "onFilter",
    "max",
    "min"
  ]);
  const margin = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    const newMargin = __spreadValues({}, value);
    if ((value == null ? void 0 : value.lte) === void 0 || (value == null ? void 0 : value.lte) >= max) {
      newMargin.lte = max;
    }
    if ((value == null ? void 0 : value.gte) === void 0 || (value == null ? void 0 : value.gte) <= min) {
      newMargin.gte = min;
    }
    return newMargin;
  }, [max, min, JSON.stringify(value)]);
  const { isMobile } = (0,_contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_2__/* .useDevice */ .F)();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InputNumberGroups, {
    justify: "space-between",
    marginBottom: "s4"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCurrency, {
    value: margin.gte
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCurrency, {
    value: margin.lte
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .InputSlider */ .s, {
    range: true,
    size: isMobile ? _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.xl */ .mO.xl : _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.xs */ .mO.xs,
    min,
    max,
    step,
    value: [margin.gte, margin.lte],
    onChange: ([gte, lte]) => {
      const value2 = {
        lte: Math.min(lte, max),
        gte: Math.max(gte, min)
      };
      onFilter == null ? void 0 : onFilter(value2.gte, value2.lte);
    },
    changeOn: "dragend"
  }));
};
const Wrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Shape */ .b)``;
const InputNumberGroups = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .k)(({ theme }) => `
  position: relative;
  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 0px;
    border-top: 1px solid ${theme.colors.divider};
    top:50%;
    z-index: 0;
  }
`);
const StyledCurrency = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Currency */ .F)(({ theme }) => `
  width: 75px;
  padding: 0.25rem;
  border: 1px solid ${theme.colors.divider};
  font-size: 0.7rem;
  border-radius: ${theme.borderRadius.s};
  background-color: ${theme.colors.white};
  z-index: 0;
  text-align: center;
`);




/***/ }),

/***/ 47846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kr": function() { return /* binding */ cookFilterPrice; }
/* harmony export */ });
/* unused harmony exports onRedirect, onSearch, onSort, getActivatedFilters, removeFilter, convertFilters */
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27250);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


const onRedirect = (type, pathname, query)=>{
    if (type === "push") {
        Router.push({
            pathname: pathname,
            query: query
        });
    } else if (type === "replace") {
        Router.replace({
            pathname: pathname,
            query: query
        });
    }
};
const onSearch = (type, query)=>{
    const currentQuery = Router.query;
    const pathname = query.q ? "/search" : currentQuery.categoryId ? "/categories/".concat(currentQuery.categoryId) : Router.pathname;
    if (!Object.keys(query).length) {
        onRedirect(type, pathname, currentQuery.q ? {
            q: currentQuery.q
        } : {});
        return;
    }
    if (query.hasOwnProperty("_page") && query._page === currentQuery._page) {
        delete query._page;
    }
    if (currentQuery.q) {
        query = _objectSpread({}, _objectSpread({
            q: currentQuery.q
        }, query));
    }
    onRedirect(type, pathname, query);
};
const onSort = (_sort)=>{
    const queryStringObj = Router.query;
    let _order = queryStringObj._order ? queryStringObj._order : "desc";
    if (_sort === "bestPrice") {
        _order === "desc" ? _order = "asc" : _order = "desc";
    }
    if (_sort) {
        onSearch("push", _objectSpread({}, queryStringObj, {
            _sort: _sort,
            _order: _order
        }));
    } else {
        delete queryStringObj._sort;
        delete queryStringObj._order;
        onRedirect("push", Router.pathname, queryStringObj);
    }
};
const getActivatedFilters = (filters)=>{
    const queryStringObj = Router.query;
    const activatedFilters = [];
    Object.keys(queryStringObj).forEach((queryItem)=>{
        filters.forEach((filter)=>{
            if (filter.code === queryItem) {
                filter.values.forEach((value)=>{
                    if (((queryStringObj === null || queryStringObj === void 0 ? void 0 : queryStringObj[queryItem]) || "").includes(value.option)) {
                        activatedFilters.push(value);
                    }
                });
            }
        });
    });
    return activatedFilters;
};
const removeFilter = (filterValue, activeFilters)=>{
    const newActivatedFilters = activeFilters.filter((item)=>{
        return item.option !== filterValue.option;
    });
    if (!newActivatedFilters.length) {
        onSearch("push", {});
        return;
    }
    const newActivatedFiltersQuery = newActivatedFilters.reduce((obj, item)=>{
        obj[item.code] = obj[item.code] || [];
        obj[item.code].push(item.option);
        return obj;
    }, {});
    const convertedFiltersQuery = {};
    Object.keys(newActivatedFiltersQuery).forEach((key)=>{
        convertedFiltersQuery[key] = newActivatedFiltersQuery[key].join();
    });
    onSearch("push", convertedFiltersQuery);
};
const convertFilters = (filters)=>{
    const newFilters = filters.map((filter)=>{
        const newValues = filter.values.map((item)=>{
            return _objectSpread({}, item, {
                code: filter.code,
                name: filter.name
            });
        });
        filter.values = newValues;
        return filter;
    });
    return newFilters;
};
const cookFilterPrice = function() {
    let lte = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10000000, gte = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    /**
   * default : gte: 0, lte: 10.000.000, step = 500.000, delta = lte - gte
   * lte: is rounded to 50k, 500K, 1M, 5M
   * step = (delta / 20) is rounded to 5k, 10k, 100K, 500K
   */ lte = lte === null || isNaN(lte) ? 10000000 : lte;
    gte = gte === null || isNaN(gte) ? 0 : gte;
    let priceLte = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__/* .stringToInteger */ .C)(lte.toString()) || (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__/* .stringToInteger */ .C)(gte.toString(), 0) + 500000;
    const priceGte = 0;
    if (priceLte < 200000) {
        priceLte = Math.ceil(priceLte / 50000) * 50000;
    }
    if (priceLte > 200000 && priceLte < 500000) {
        priceLte = 500000;
    }
    if (priceLte > 500000 && priceLte < 5000000) {
        priceLte = Math.ceil(priceLte / 1000000) * 1000000;
    }
    if (priceLte > 5000000) {
        priceLte = Math.ceil(priceLte / 5000000) * 5000000;
    }
    const delta = priceLte - priceGte;
    let step = 100000;
    if (delta < 200000) {
        step = Math.ceil(delta / 100000) * 5000;
    /**minStep : 5.000d , maxStep: 10.000 */ }
    if (delta > 200000 && delta <= 2000000) {
        step = Math.ceil(delta / 200000) * 10000;
    /**minStep : 20.000d , maxStep: 100.000 */ }
    if (delta > 2000000 && delta <= 10000000) {
        step = Math.ceil(delta / 2000000) * 100000;
    /**minStep : 100.000d , maxStep: 500.000 */ }
    if (delta > 10000000) {
        step = 500000;
    }
    // steps
    return {
        max: priceLte,
        min: priceGte,
        step: step
    };
};


/***/ }),

/***/ 36738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "To": function() { return /* binding */ extractSortQuery; },
  "L0": function() { return /* binding */ useFilter; }
});

// UNUSED EXPORTS: joinSortQuery

// EXTERNAL MODULE: ./contexts/ScreenContext.tsx + 1 modules
var ScreenContext = __webpack_require__(99170);
// EXTERNAL MODULE: ../../packages/tracking/dist/cart.es.js
var cart_es = __webpack_require__(46586);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../packages/log/dist/index.es.js + 1 modules
var index_es = __webpack_require__(20577);
;// CONCATENATED MODULE: ./types/others.ts
var OrderBy;
(function(OrderBy) {
    OrderBy["ASC"] = "ASC";
    OrderBy["DESC"] = "DESC";
})(OrderBy || (OrderBy = {}));

// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(34655);
// EXTERNAL MODULE: ./helpers/discovery.ts + 1 modules
var discovery = __webpack_require__(60295);
;// CONCATENATED MODULE: ./hooks/useFilter.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};








const getActiveOptions = (query, optionDictionary)=>{
    const activatedFilters = [];
    Object.keys(query).forEach((key)=>{
        try {
            const values = query[key];
            const filterValues = typeof values == "string" ? values.split(",") : values;
            filterValues.forEach((value)=>{
                if (optionDictionary[value] && key === optionDictionary[value].filterCode) {
                    activatedFilters.push(optionDictionary[value]);
                }
            });
        } catch (err) {
            // There is this error thrown in server log
            // TypeError: values.split is not a function
            // defend against that error
            index_es/* logger.error */.k.error(err);
            index_es/* logger.error */.k.error("Problematic query key: ".concat(key, " value: ").concat(query[key]));
        }
    });
    return activatedFilters.map((filter)=>_objectSpread({}, filter));
};
const SORT_QUERY_JOIN_CHAR = "&";
const joinSortQuery = (param)=>{
    let { sort , order  } = param;
    return "".concat(sort).concat(SORT_QUERY_JOIN_CHAR).concat(order);
};
const extractSortQuery = (joinedQuery)=>{
    return joinedQuery.split(SORT_QUERY_JOIN_CHAR);
};
const defaultSortOptions = [
    {
        optionName: (0,i18n.t)("Mặc định"),
        optionCode: null,
        filterCode: null,
        filterName: (0,i18n.t)("Sắp xếp theo")
    },
    {
        optionName: (0,i18n.t)("Phổ biến nhất"),
        optionCode: joinSortQuery({
            sort: "SORT_BY_TOP_SALE_QUANTITY_90_DAYS",
            order: OrderBy.DESC
        }),
        filterCode: "sort",
        filterName: (0,i18n.t)("Sắp xếp theo")
    },
    {
        optionName: (0,i18n.t)("Khuyến m\xe3i tốt nhất"),
        optionCode: joinSortQuery({
            sort: "SORT_BY_DISCOUNT_PERCENT",
            order: OrderBy.DESC
        }),
        filterCode: "sort",
        filterName: (0,i18n.t)("Sắp xếp theo")
    },
    {
        optionName: (0,i18n.t)("Gi\xe1 tăng dần"),
        optionCode: joinSortQuery({
            sort: "SORT_BY_PRICE",
            order: OrderBy.ASC
        }),
        filterCode: "sort",
        filterName: (0,i18n.t)("Sắp xếp theo")
    },
    {
        optionName: (0,i18n.t)("Gi\xe1 giảm dần"),
        optionCode: joinSortQuery({
            sort: "SORT_BY_PRICE",
            order: OrderBy.DESC
        }),
        filterCode: "sort",
        filterName: (0,i18n.t)("Sắp xếp theo")
    },
    {
        optionName: (0,i18n.t)("Sản phẩm mới nhất"),
        optionCode: joinSortQuery({
            sort: "SORT_BY_PUBLISH_AT",
            order: OrderBy.DESC
        }),
        filterCode: "sort",
        filterName: (0,i18n.t)("Sắp xếp theo")
    },
    {
        optionName: (0,i18n.t)("Sản phẩm b\xe1n chạy nhất"),
        optionCode: joinSortQuery({
            sort: "SORT_BY_TOP_SALE_QUANTITY_7_DAYS",
            order: OrderBy.DESC
        }),
        filterCode: "sort",
        filterName: (0,i18n.t)("Sắp xếp theo")
    }, 
];
const useFilter = (filters, options)=>{
    const router = (0,next_router.useRouter)();
    const { query  } = router;
    const { trackingScreenName  } = (0,ScreenContext/* useScreen */.E)();
    const { 0: newQuery , 1: setNewQuery  } = (0,react.useState)(query);
    const rootPath =  true ? window.location.pathname : 0;
    const clearFilterLink = rootPath === "/search" ? "/search?router=productListing".concat(query.query ? "&query=".concat(query.query) : "") : "".concat( true ? window.location.origin : 0).concat(rootPath);
    // Passing all filter values array to object to search by key, avoid loop, time complexity O(1)
    const optionDictionary = (0,react.useMemo)(()=>filters.reduce((acc, cur)=>{
            return [
                ...acc,
                ...cur.options
            ];
        }, []).reduce((acc, cur)=>{
            const optionCode = cur.optionCode;
            return _objectSpreadProps(_objectSpread({}, acc), {
                [optionCode]: cur
            });
        }, {}), [
        JSON.stringify(filters)
    ]);
    const displayFilters = (0,react.useMemo)(()=>filters.filter((filter)=>filter.options.length > 1), [
        filters
    ]);
    const activeOptions = (0,react.useMemo)(()=>({
            activeFilterOptions: getActiveOptions(newQuery, optionDictionary),
            activeSortOption: defaultSortOptions.find((opt)=>opt.optionCode === joinSortQuery({
                    sort: newQuery.sort,
                    order: newQuery.order
                })) || defaultSortOptions[0]
        }), [
        newQuery
    ]);
    (0,react.useEffect)(()=>{
        setNewQuery(query);
    }, [
        JSON.stringify(query)
    ]);
    const submit = ()=>{
        modifyBehaviorBaseOnOptions(newQuery, {
            autoSubmit: true
        });
    };
    const changeRouteQuery = (routeQuery)=>{
        router.push({
            pathname: router.pathname,
            query: routeQuery
        }, {
            pathname: rootPath,
            query: (0,discovery/* omitQuery */.pt)(routeQuery)
        }, {
            shallow: true
        });
    };
    const modifyBehaviorBaseOnOptions = (routeQuery, overrideOptions)=>{
        const { autoSubmit  } = _objectSpread({}, options, overrideOptions);
        setNewQuery(routeQuery);
        if (autoSubmit) {
            changeRouteQuery(routeQuery);
            const { price_gte , price_lte  } = routeQuery;
            const targetUrl = new URL(window.location.origin);
            targetUrl.pathname = rootPath;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            targetUrl.search = new URLSearchParams(routeQuery).toString();
            (0,cart_es/* trackManually */.gu)("applyFilter", "sortFilterProduct", trackingScreenName, JSON.stringify(_objectSpreadProps(_objectSpread({
                screenName: trackingScreenName
            }, price_gte ? {
                validatedPriceGte: price_gte
            } : {}, price_lte ? {
                validatedPriceLte: price_lte
            } : {}), {
                url: targetUrl.toString()
            })));
        }
    };
    const onClickFilterOption = (0,react.useCallback)((value, options)=>{
        const { page  } = newQuery, filterParams = _objectWithoutProperties(newQuery, [
            "page"
        ]);
        let routeQuery;
        const targetUrl = new URL(window.location.origin);
        targetUrl.pathname = rootPath;
        const trackingData = {
            contentName: "",
            regionName: "sortFilterProduct",
            target: trackingScreenName,
            payload: {}
        };
        if (value.filterCode === "price") {
            const { ["price_gte"]: tbr , ["price_lte"]: tbr2  } = filterParams, restFilterParams = _objectWithoutProperties(filterParams, [
                "price_gte",
                "price_lte"
            ]);
            routeQuery = restFilterParams;
        } else if (filterParams[value.filterCode]) {
            var ref;
            // if filterCode existed
            const filterCodeValues = ((ref = filterParams[value.filterCode]) === null || ref === void 0 ? void 0 : ref.toString().split(",")) || [];
            const index = filterCodeValues.indexOf(value.optionCode);
            // if this option is selected before
            if (index !== -1) {
                filterCodeValues.splice(index, 1);
            } else {
                // else if we are select a new option
                filterCodeValues.push(value.optionCode);
                trackingData.contentName = value.optionName;
                trackingData.payload = {
                    attributeCode: value.optionCode,
                    attributeName: value.optionName,
                    screenName: trackingScreenName
                };
            }
            if (filterCodeValues.length) {
                routeQuery = _objectSpreadProps(_objectSpread({}, filterParams), {
                    [value.filterCode]: filterCodeValues.join(",")
                });
            } else {
                const _filterCode = value.filterCode, { [_filterCode]: tbr1  } = filterParams, restFilterParams1 = _objectWithoutProperties(filterParams, [
                    _filterCode
                ].map(_toPropertyKey));
                routeQuery = restFilterParams1;
            }
        } else {
            routeQuery = _objectSpreadProps(_objectSpread({}, filterParams), {
                [value.filterCode]: value.optionCode
            });
            trackingData.contentName = value.optionName;
            trackingData.payload = {
                attributeCode: value.filterCode,
                attributeName: value.filterName,
                screenName: trackingScreenName
            };
        }
        // if user select a filter then track
        if (trackingData.contentName) {
            targetUrl.search = new URLSearchParams(routeQuery).toString();
            trackingData.payload = {
                url: targetUrl.toString()
            };
            (0,cart_es/* trackManually */.gu)(trackingData.contentName, trackingData.regionName, trackingData.target, JSON.stringify(trackingData.payload));
        }
        modifyBehaviorBaseOnOptions(routeQuery, options);
    }, [
        newQuery
    ]);
    const onSortByPrice = (0,react.useCallback)(function() {
        let priceGte = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, priceLte = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, options = arguments.length > 2 ? arguments[2] : void 0;
        const { page , price_gte , price_lte  } = newQuery, filterParams = _objectWithoutProperties(newQuery, [
            "page",
            "price_gte",
            "price_lte"
        ]);
        const [validPriceGte, validPriceLte] = priceGte < priceLte ? [
            priceGte,
            priceLte
        ] : [
            priceLte,
            priceGte
        ];
        const routeQuery = _objectSpread({}, filterParams, validPriceGte && {
            price_gte: validPriceGte
        }, validPriceLte && {
            price_lte: validPriceLte
        });
        modifyBehaviorBaseOnOptions(routeQuery, options);
        (0,cart_es/* trackManually */.gu)("sortProductResult", "sortFilterProduct", "".concat(priceGte, ",").concat(priceLte), "pricerange");
    }, [
        newQuery
    ]);
    const onSortOptionSelected = (0,react.useCallback)((sort, order, options)=>{
        const { page  } = newQuery, filterParams = _objectWithoutProperties(newQuery, [
            "page"
        ]);
        let routeQuery;
        if (sort === null && order === null || sort === query.sort && order === query.order) {
            const { sort: tbr , order: tbr2  } = filterParams, restFilterParams = _objectWithoutProperties(filterParams, [
                "sort",
                "order"
            ]);
            routeQuery = restFilterParams;
        } else {
            routeQuery = _objectSpreadProps(_objectSpread({}, filterParams), {
                sort: sort,
                order: order
            });
        }
        modifyBehaviorBaseOnOptions(routeQuery, options);
    }, [
        newQuery
    ]);
    const onChangePage = (0,react.useCallback)((pageNumber, options)=>{
        const routeQuery = _objectSpread({}, newQuery, {
            page: pageNumber
        });
        modifyBehaviorBaseOnOptions(routeQuery, options);
    }, [
        newQuery
    ]);
    const clearNewQuery = ()=>{
        setNewQuery(query);
    };
    return _objectSpreadProps(_objectSpread({
        displayFilters,
        optionDictionary: optionDictionary
    }, activeOptions), {
        onClickFilterOption,
        onSortByPrice,
        onSortOptionSelected,
        onChangePage,
        clearFilterLink,
        submit,
        defaultSortOptions,
        clearNewQuery
    });
};


/***/ })

}]);